<template>
	<div>
		<v-layout row wrap>
			<v-flex sm12 md6>
				<p class="add-event-example-sub-header-light mb-1">Last Step</p>
				<p class="add-event-step-header-big mb-2">Review and Submit</p>
				<p class="add-event-review-header">Please review your event details below. 
					If everything looks good, go ahead and submit! That’s it. Your event should be ready and published for the community within 24hrs.
				</p>

				<p class="d-inline-block add-event-review-header mb-2">Location use and permit</p>
				<p class="add-event-step-error mb-2" v-if="!confirmLocationUse">Please review and confirm the following statement</p>
				<p class="add-event-review-content-light">
					I hereby affirm that all information above is accurate and truthful, and agree to host this event and provide guests with the provisions and amenities as I have indicated above.
					<v-checkbox v-model="confirmLocationUse" label="Confirm" class="mt-2" color="link"></v-checkbox>
				</p>

				<p class="add-event-step-error mb-2" v-if="!getAddEventReadyToSubmit">
					There are one or more incomplete parts. Please review form and re-submit.
				</p>

				<v-layout row wrap class="mt-2 mb-5">
					<v-flex xs12>
						<p class="d-inline-block add-event-review-header">Event Date &amp; Time</p>
						<v-btn style="float: right; min-width:30px!important; width:auto!important;" small flat :to="{name: 'host_add_event_schedule'}">Edit</v-btn>
						<p class="add-event-step-error mb-2" v-if="getAddEventProp('date') === null">You must choose a date for your wkrprty.</p>
						<p class="add-event-step-error mb-2" 
							v-if="getAddEventProp('startTime') === null ||
								getAddEventProp('endTime') === null ||
								timeError">
							You must choose a valid time for your wkrprty.
						</p>
						<p class="add-event-review-content">{{formattedTime}}&nbsp;{{formattedDate}}&nbsp;<span v-if="getAddEventProp('frequency') != 'one-time'">({{getAddEventProp('frequency')}} {{getAddEventProp('recurringFrequency')}})</span></p>
						
						<v-divider class="mt-2 mb-3"></v-divider>
						
						<p class="d-inline-block add-event-review-header">Event Type</p>
						<v-btn style="float: right; min-width:30px!important; width:auto!important;" small flat :to="{name: 'host_add_event_type'}">Edit</v-btn>
						<p class="add-event-step-error mb-2" v-if="getAddEventProp('wrkprtyType') === null">You must select a wrkprty type.</p>
						<p class="add-event-review-content"> {{getAddEventProp('wrkprtyType')}}</p>

						<v-divider class="mt-2 mb-3"></v-divider>

						<!-- <div v-if="this.getAddEventProp('wrkprtyType') === 'wrkprty'">
							<p class="d-inline-block add-event-review-header">Event Format</p>
							<v-btn style="float: right; min-width:30px!important; width:auto!important;" small flat :to="{name: 'host_add_event_format'}">Edit</v-btn>
							<p class="add-event-step-error mb-2" v-if="getAddEventProp('format') === null">You must select a format.</p>

							<v-card flat style="min-height: 100px; max-width: 88vw;" v-else>
								<v-card-title class="pa-2">
									<p class="add-event-step-sub-header mb-0" style="color: #666">{{getAddEventProp('formatDescription')}}</p>
								</v-card-title>
								<v-card-text class="pa-3">
									<v-layout justify-center align-center fill-height>
										<div v-for="block in getAddEventProp('format')" :style="getFormatBlockStyle(block)">
											&nbsp;
										</div>
									</v-layout>
								</v-card-text>
							</v-card>

							<v-divider class="mt-2 mb-3"></v-divider>
						</div> -->

						<p class="d-inline-block add-event-review-header">Location</p>
						<v-btn style="float: right; min-width:30px!important; width:auto!important;" small flat :to="{name: 'host_add_event_location'}">Edit</v-btn>
						<p class="add-event-step-error mb-2" v-if="!getAddEventProp('location')">You must select one of your locations.</p>
						<div v-else class="mb-3">
							<v-avatar size="32">
								<img :src="selectedLocation.primary_image.image">
							</v-avatar>
							<span class="ml-3 add-event-review-content" v-if="selectedLocation">
								{{ selectedLocation.name }}
							</span>
						</div>

						<v-divider class="mt-2 mb-3"></v-divider>

						<p class="d-inline-block add-event-review-header">Event Name</p>
						<v-btn style="float: right; min-width:30px!important; width:auto!important;" small flat :to="{name: 'host_add_event_description'}">Edit</v-btn>
						<p class="add-event-step-error mb-2" v-if="getAddEventProp('title') === null">You must enter a title for your wkrprty.</p>
						<p class="add-event-review-content" v-if="selectedLocation"> {{getAddEventProp('title')}} @ {{selectedLocation.name}}</p>

						<v-divider class="mt-2 mb-3"></v-divider>

						<p class="d-inline-block add-event-review-header">Tagline</p>
						<v-btn style="float: right; min-width:30px!important; width:auto!important;" small flat :to="{name: 'host_add_event_description'}">Edit</v-btn>
						<p class="add-event-step-error mb-2" v-if="getAddEventProp('subtitle') === null">You must enter a subtitle for your wkrprty.</p>
						<p class="add-event-step-error mb-2" v-else-if="subtitleError">Your subtitle must be less less than 100 characters.</p>
						<p class="add-event-review-content"> {{getAddEventProp('subtitle')}}</p>
						
						<v-divider class="mt-2 mb-3"></v-divider>

						<p class="d-inline-block add-event-review-header">Description (What to expect)</p>
						<v-btn style="float: right; min-width:30px!important; width:auto!important;" small flat :to="{name: 'host_add_event_description'}">Edit</v-btn>
						<p class="add-event-step-error mb-2" v-if="getAddEventProp('description') === null">You must enter a description for your wkrprty.</p>
						<p class="add-event-step-error mb-2" v-else-if="descriptionErrorShort">Your description is too short.</p>
						<p class="add-event-step-error mb-2" v-else-if="descriptionErrorLong">Your description is too long.</p>
						<p class="add-event-review-content" v-html="newlines(getAddEventProp('description'))"></p>
						
						<v-divider class="mt-2 mb-3"></v-divider>

						<div v-if="addonStarted">
							<p class="d-inline-block add-event-review-header">Event Addon</p>
							<v-btn style="float: right; min-width:30px!important; width:auto!important;" small flat :to="{name: 'host_add_event_extras'}">Edit</v-btn>
							<p class="add-event-step-error mb-2" v-if="!isAddonValid">Invalid Addon</p>
							<p class="add-event-review-content mb-2" v-else>${{getAddEventProp('addonPrice')}} {{getAddEventProp('addonTitle')}} {{getAddEventProp('addonTimeSlot')}} event from {{formattedAddonTime}}</p>

							<v-divider class="mt-2 mb-3"></v-divider>
						</div>
						
						<p class="d-inline-block add-event-review-header">Host Notes</p>
						<v-btn style="float: right; min-width:30px!important; width:auto!important;" small flat :to="{name: 'host_add_event_notes'}">Edit</v-btn>
						<p class="add-event-review-content" v-html="newlines(getAddEventProp('notes'))"></p>

						<v-divider class="mt-2 mb-3"></v-divider>

						<p class="d-inline-block add-event-review-header">House Rules</p>
						<v-btn style="float: right; min-width:30px!important; width:auto!important;" small flat :to="{name: 'host_add_event_notes'}">Edit</v-btn>
						<p class="add-event-review-content" v-html="newlines(getAddEventProp('rules'))"></p>

						<v-divider class="mt-2 mb-3"></v-divider>

						<p class="d-inline-block add-event-review-header">Open to...</p>
						<v-btn style="float: right; min-width:30px!important; width:auto!important;" small flat :to="{name: 'host_add_event_restrictions'}">Edit</v-btn>
						<choice-field-display class="pb-3" :original="eventRestrictionOptions" :fields="getAddEventProp('restrictionInfo')" :inputs="getAddEventProp('restrictionInfoInputs')"></choice-field-display>

						<v-divider class="mt-2 mb-3"></v-divider>

						<p class="d-inline-block add-event-review-header">Guest Approval Method</p>
						<v-btn style="float: right; min-width:30px!important; width:auto!important;" small flat :to="{name: 'host_add_event_restrictions'}">Edit</v-btn>
						<p class="add-event-review-content">{{approvalOption}}</p>

						<v-divider class="mt-2 mb-3"></v-divider>

						<p class="d-inline-block add-event-review-header">Provisions (Things I'll provide for attendees)</p>
						<v-btn style="float: right; min-width:30px!important; width:auto!important;" small flat :to="{name: 'host_add_event_amenities'}">Edit</v-btn>
						<choice-field-display class="pb-3" :original="eventProvisionsOptions" :fields="getAddEventProp('provisions')" :inputs="getAddEventProp('provisionsInputs')"></choice-field-display>
					
						<v-divider class="mt-2 mb-3"></v-divider>

						<p class="d-inline-block add-event-review-header">Event Location Amenities</p>
						<v-btn style="float: right; min-width:30px!important; width:auto!important;" small flat :to="{name: 'host_add_event_amenities'}">Edit</v-btn>
						<choice-field-display class="pb-3" :original="locationInfoOptions" :fields="getAddEventProp('locationInfo')" :inputs="getAddEventProp('locationInfoInputs')"></choice-field-display>

						<v-divider class="mt-2 mb-3"></v-divider>

						<p class="d-inline-block add-event-review-header">Maximum Number of Attendees / Guests</p>
						<v-btn style="float: right; min-width:30px!important; width:auto!important;" small flat :to="{name: 'host_add_event_seating'}">Edit</v-btn>
						<p class="add-event-step-error mb-2" v-if="(getAddEventProp('seats') === null || seatsError)">You must choose a valid number of seats.</p>
						<p class="add-event-review-content"> {{getAddEventProp('seats')}}</p>
						
						<v-divider class="mt-2 mb-3"></v-divider>

						<p class="d-inline-block add-event-review-header">Event Ticket Price</p>
						<v-btn style="float: right; min-width:30px!important; width:auto!important;" small flat :to="{name: 'host_add_event_seating'}">Edit</v-btn>
						<p class="add-event-step-error mb-2" v-if="(getAddEventProp('price') === null)">You must choose a valid price.</p>
						<p class="add-event-review-content"> $ {{getAddEventProp('price')}} per person</p>
						
						<v-divider class="mt-2 mb-3"></v-divider>

						<p class="d-inline-block add-event-review-header">Photos:</p>
						<v-btn style="float: right; min-width:30px!important; width:auto!important;" small flat :to="{name: 'host_add_event_photos'}">Edit</v-btn>
						<p class="add-event-step-error mb-2" v-if="getAddEventProp('images').length < 1">You must upload at least one photo</p>
						<p class="add-event-step-error mb-2" v-if="getAddEventProp('primaryImage') === null">You must select a primary photo</p>
						<vue-dropzone
							ref="imageDropzone"
							id="dropzone"
							:options="dropzoneOptions"
						></vue-dropzone>
					</v-flex>
				</v-layout>
			</v-flex>
			<v-flex md4 offset-md1 class="hidden-sm-and-down">
				<v-card class="add-event-tip-box">
					<v-card-text class="p-relative pt-5">
						<div class="info-trapezoid p-absolute">
							<div class="info-content">
								<img src="/static/images/icon/light-bulb-gray.svg" width="40" />
							</div>
						</div>
						<p class="add-event-tip-title">Double check...</p>
						<p class="add-event-tip-content">Please check to make sure everything is accurate and that you haven’t missed anything before submitting your event.</p>
						<p class="add-event-tip-content">Make sure your guests have the most up to date information possible.</p>
						<p class="add-event-tip-content">It it looks right to you, please submit.</p>
						<p class="add-event-tip-content">The earlier we get this information from you, the better!</p>
						<p class="add-event-tip-content">Even if your event is a month away, we want to make sure to get you on the calendar so people have time to plan.</p>
						<p class="add-event-tip-content">Thanks!</p>
					</v-card-text>
				</v-card>
			</v-flex>
			<v-dialog scrollable v-model="infoDialog">
				<v-card style="width: 100%">
					<v-card-title class="mb-0 pb-2 pt-3">
						<img class="info-mobile-icon" src="/static/images/icon/light-bulb-gray.svg" />
					</v-card-title>
					<v-card-text style="max-height:50vh;">
						<p class="add-event-tip-title">Double check...</p>
						<p class="add-event-tip-content">Please check to make sure everything is accurate and that you haven’t missed anything before submitting your event.</p>
						<p class="add-event-tip-content">Make sure your guests have the most up to date information possible.</p>
						<p class="add-event-tip-content">It it looks right to you, please submit.</p>
						<p class="add-event-tip-content">The earlier we get this information from you, the better!</p>
						<p class="add-event-tip-content">Even if your event is a month away, we want to make sure to get you on the calendar so people have time to plan.</p>
						<p class="add-event-tip-content">Thanks!</p>
					</v-card-text>
					<v-card-actions>
						<v-spacer>
						</v-spacer>
						<v-btn icon class="info-mobile-dialog-close-button" @click="infoDialog=false"><v-icon>close</v-icon></v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>
		</v-layout>
	</div>
</template>

<script>
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.css'

import { mapActions, mapGetters } from 'vuex'
import {
	locationInfoOptions,
	eventProvisionsOptions,
	eventRestrictionOptions
} from '~/store/util/values'
import ChoiceFieldDisplay from '~/components/ChoiceFieldDisplay'
import { replaceNewlines } from '~/store/util/util'
import moment from 'moment'
export default {
	data() {
		return {
			dropzoneOptions: {
				paramName: 'image',
				url: '/api/v1/image-upload/',
				clickable: false,
				thumbnailWidth: 150,
				acceptedFiles: 'image/*',
				maxFilesize: 10,
				ignoreHiddenFiles: true,
				dictDefaultMessage:
					'<i class="fa fa-cloud-upload"></i><br>Drop or click to upload images'
			},
			locationInfoOptions: locationInfoOptions,
			eventProvisionsOptions: eventProvisionsOptions,
			eventRestrictionOptions: eventRestrictionOptions,
			types: [
				{
					title: 'Wrkprty',
					value: 'wrkprty',
					description: 'Host guests to facilitate focus and connection.'
				},
				{
					title: 'Wrkshop',
					value: 'wrkshop',
					description: 'This is a work shop'
				},
				{
					title: 'Mstrmnd',
					value: 'mstrmnd',
					description: 'This is smart work party'
				},
				{
					title: 'Prsnts',
					value: 'prsnts',
					description: 'This is the presentation'
				}
			],
			recurringTypes: [
				{
					title: 'One-time Event',
					value: 'one-time',
					description:
						'Host this wrkprty once.  We"ll save your event info so you can host it again in the future.'
				},
				{
					title: 'Recurring Event',
					value: 'recurring',
					description: 'Host this wrkprty recurring every week or month.'
				}
				// { title: 'Series', value: 'series', description: 'Host a series of wrkprtys that progress toward a goal.' },
			],
			rules: {
				price: value => {
					if (value >= 10) {
						this.validPrice = true
						return true
					}
					this.validPrice = false
					return 'Tickets must be more than $10'
				},
				seats: value => {
					if (value >= 5) {
						this.validSeats = true
						return true
					}
					this.validSeats = false
					return 'Must have at least 5 guests for a wrkprty'
				}
			},
			datePicker: false,
			timePicker: false,
			startTimes: [
				'8:00am',
				'9:00am',
				'10:00am',
				'11:00am',
				'12:00pm',
				'1:00pm',
				'2:00pm',
				'3:00pm',
				'4:00pm'
			],
			endTimes: [
				'12:00pm',
				'1:00pm',
				'2:00pm',
				'3:00pm',
				'4:00pm',
				'5:00pm',
				'6:00pm',
				'7:00pm',
				'8:00pm',
				'9:00pm',
				'10:00pm',
				'11:00pm',
				'12:00am'
			],
			removingImage: false
		}
	},
	components: {
		ChoiceFieldDisplay: ChoiceFieldDisplay,
		vueDropzone: vue2Dropzone
	},
	methods: {
		...mapActions([
			'setAddEventProp',
			'fetchAllLocations',
			'addEventProcessFiles'
		]),
		removePhoto(index) {
			this.removingImage = true
		},
		clickImage(index) {
			if (this.removingImage === false) {
				this.setAddEventProp({
					prop: 'primaryImage',
					value: index
				})
			} else {
				let images = this.getAddEventProp('images').slice(0)
				let urls = this.getAddEventProp('imagesUrls').slice(0)
				let selectedIndex = this.getAddEventProp('primaryImage')
				images.splice(index, 1)
				urls.splice(index, 1)
				this.removingImage = false

				if (index === selectedIndex) {
					selectedIndex = 0
				} else if (index < selectedIndex) {
					selectedIndex -= 1
				}

				this.setAddEventProp({
					prop: 'images',
					value: images
				})
				this.setAddEventProp({
					prop: 'imagesUrls',
					value: urls
				})
			}
		},
		onFilePicked(event) {
			this.addEventProcessFiles(event.target.files)
		},
		newlines(value) {
			return replaceNewlines(value)
		},
		getFormatBlockStyle(block) {
			let color = ''
			let width = ''
			if (block.type === 'break') {
				color = '#2CA0D2'
			} else if (block.type === 'arrival') {
				color = '#9DFAC3'
			} else {
				color = '#74cbf1'
			}
			width = Math.round(block.duration * 80)
			let style = {
				'background-color': color,
				'border-radius': '10px',
				'width': width + 'px!important',
				'height': '13px',
				'display': 'inline-block',
				'margin-right': '3px'
			}
			return style
		},
	},
	created() {
		// if (window.location)
		console.log('created')
		let params = window.location.search.slice(1).split(/[\?\&]+/)
		for (let param in params) {
			let prop = params[param].split('=')[0]
			let value = params[param].split('=')[1]
			if (prop === 'location') {
				this.location = value
				this.setAddEventProp({
					prop: 'location',
					value: parseInt(value)
				})
			}
		}
		this.setAddEventProp({ prop: 'visitedSubmit', value: true })
	},
	mounted() {
		// Set images
		console.log('mounted')
		let imageObjs = this.getAddEventProp('imageObjs')
		let mockImage
		for (let i = 0; i < imageObjs.length; i++) {
			mockImage = { name: imageObjs[i].name, type: "image/*", size: imageObjs[i].filesize }
			this.$refs.imageDropzone.manuallyAddFile(mockImage, imageObjs[i].image)
		}
	},
	computed: {
		...mapGetters([
			'getAddEventProp',
			'getLocation',
			'getMyLocations',
			'getEventTags',
			'getAddEventReadyToSubmit'
		]),
		approvalOption() {
			let option = this.getAddEventProp('approvalOption')
			if (option === 'instant_book') {
				return 'Guests are instantly approved for your event'
			}
			if (option === 'level_one') {
				return 'Guests who have been to one or more WRKPRTYs will be instantly booked. New guests must be approved before attending'
			}
			if (option === 'all_need_approval') {
				return 'You must approve all guests before they can attend your event.'
			}
		},
		infoDialog: {
			get() {
				return this.getAddEventProp('infoDialog')
			},
			set(val) {
				this.setAddEventProp({ prop: 'infoDialog', value: val })
			}
		},
		selectedLocation() {
			return this.getAddEventProp('location')
		},
		// getAddonDuration () {
		// 	let duration = this.getAddEventProp('addonDuration').split('.')
		// 	let hour = ''
		// 	let min = ''
		// 	if (duration.length === 2) {
		// 		hour = parseFloat(duration[0])
		// 		min = 60 * parseFloat('.' + duration[1])
		// 	}
		// 	let durationString = ''
		// 	if (hour !== 0) {
		// 		if (hour > 1) {
		// 			durationString += hour + ' hours'
		// 		} else {
		// 			durationString += hour + ' hour'
		// 		}
		// 		if (min !== 0) {
		// 			durationString += ' and ' + min + ' minutes'
		// 		}
		// 	} else {
		// 		durationString += min + ' minutes'
		// 	}
		// 	return durationString
		// },
		typeSelection: {
			get() {
				return this.getAddEventProp('wrkprtyType')
			},
			set(val) {
				this.setAddEventProp({ prop: 'wrkprtyType', value: val })
			}
		},
		title: {
			get() {
				return this.getAddEventProp('title')
			},
			set(val) {
				this.setAddEventProp({ prop: 'title', value: val })
			}
		},
		subtitle() {
			return this.getAddEventProp('subtitle').slice(0, 50) + '...'
		},
		subtitleError() {
			if (this.subtitle.length > 100) {
				return true
			}
			return false
		},
		description: {
			get() {
				return this.getAddEventProp('description')
			},
			set(val) {
				this.setAddEventProp({ prop: 'description', value: val })
			}
		},
		descriptionErrorShort() {
			if (this.description.length < 200) {
				return true
			}
			return false
		},
		descriptionErrorLong() {
			if (this.description.length > 500) {
				return true
			}
			return false
		},
		date: {
			get() {
				return this.getAddEventProp('date')
			},
			set(val) {
				this.setAddEventProp({ prop: 'date', value: val })
			}
		},
		startTime: {
			get() {
				return this.getAddEventProp('startTime')
			},
			set(val) {
				this.setAddEventProp({ prop: 'startTime', value: val })
			}
		},
		timeError() {
			if (this.endTime !== null && this.startTime !== null) {
				if (this.typeSelection === 'wrkprty') {
					if (moment(this.startTime).add(4, 'h') > moment(this.endTime)) {
						return true
					}
				} else {
					if (moment(this.startTime).add(1, 'h') > moment(this.endTime)) {
						return true
					}
				}
			} else {
				return true
			}
		},
		endTime: {
			get() {
				return this.getAddEventProp('endTime')
			},
			set(val) {
				this.setAddEventProp({ prop: 'endTime', value: val })
			}
		},
		allowedDates: {
			get() {
				let dates = []
				for (var i = 0; i < 300; i++) {
					dates.push(
						moment()
							.add(i + 14, 'days')
							.format('YYYY-MM-DD')
					)
				}
				return dates
			}
		},
		frequency: {
			get() {
				return this.getAddEventProp('frequency')
			},
			set(val) {
				this.setAddEventProp({ prop: 'frequency', value: val })
			}
		},
		recurringFrequency: {
			get() {
				return this.getAddEventProp('recurringFrequency')
			},
			set(val) {
				this.setAddEventProp({ prop: 'recurringFrequency', value: val })
			}
		},
		seats: {
			get() {
				return this.getAddEventProp('seats')
			},
			set(val) {
				this.setAddEventProp({ prop: 'seats', value: val })
			}
		},
		seatsError() {
			if (this.seats < 5 || this.seats > this.getAddEventProp('maxSeats')) {
				return true
			}
			return false
		},
		price: {
			get() {
				return this.getAddEventProp('price')
			},
			set(val) {
				this.setAddEventProp({ prop: 'price', value: val })
			}
		},
		getAllTags: {
			get() {
				return this.getAddEventProp('eventTagValues')
			},
			set(val) {
				this.setAddEventProp({
					prop: 'eventTagValues',
					value: val
				})
			}
		},
		notes: {
			get() {
				return this.getAddEventProp('notes')
			},
			set(val) {
				this.setAddEventProp({ prop: 'notes', value: val })
			}
		},
		houseRules: {
			get() {
				return this.getAddEventProp('rules')
			},
			set(val) {
				this.setAddEventProp({ prop: 'rules', value: val })
			}
		},
		readyToSubmit() {
			return this.getAddEventReadyToSubmit
		},
		formattedDate() {
			return moment(this.getAddEventProp('date')).format('dddd MMMM Do')
		},
		formattedTime() {
			let start = this.getAddEventProp('startTime')
			let end = this.getAddEventProp('endTime')

			if (!start || !end) {
				return ''
			}

			return moment(start).format('h:mma') + ' - ' + moment(end).format('h:mma')
		},
		formattedAddonTime() {
			let start = this.getAddEventProp('addonStartTime')
			let end = this.getAddEventProp('addonEndTime')

			if (!start || !end) {
				return ''
			}

			return moment(start).format('h:mma') + ' - ' + moment(end).format('h:mma')
		},
		confirmLocationUse: {
			get() {
				return this.getAddEventProp('confirmLocationUse')
			},
			set(val) {
				this.setAddEventProp({ prop: 'confirmLocationUse', value: val })
			}
		},
		addonStarted() {
			return (
				this.getAddEventProp('addonTitle') !== null ||
				this.getAddEventProp('addonDescription') !== null ||
				this.getAddEventProp('addonPrice') !== null ||
				this.getAddEventProp('addonStartTime') !== null ||
				this.getAddEventProp('addonEndTime') !== null ||
				this.getAddEventProp('addonTimeSlot') !== null
			)
		},
		isAddonValid() {
			let timeError = false
			if (
				this.getAddEventProp('addonEndTime') !== null &&
				this.getAddEventProp('addonStartTime') !== null
			) {
				if (moment(this.getAddEventProp('addonStartTime')) >= moment(this.getAddEventProp('addonEndTime'))) {
					timeError = true
				}
			}
			return (
				this.getAddEventProp('addonTitle') !== null &&
				this.getAddEventProp('addonTitle') !== '' &&
				this.getAddEventProp('addonDescription') !== null &&
				this.getAddEventProp('addonPrice') !== null &&
				parseFloat(this.getAddEventProp('addonPrice')) >= 0 &&
				this.getAddEventProp('addonStartTime') !== null &&
				this.getAddEventProp('addonEndTime') !== null &&
				this.getAddEventProp('addonTimeSlot') !== null &&
				!timeError
			)
		}
	}
}
</script>
